import {Component, OnInit, Input, Output, AfterContentChecked, EventEmitter} from '@angular/core';
import {DateFilterService} from '../../../../Services/dateFilter.service';

@Component({
  selector: 'app-from-to-date-select',
  templateUrl: './from-to-date-select.component.html',
  styleUrls: ['./from-to-date-select.component.css'],
  standalone: false
})
export class FromToDateSelectComponent implements OnInit, AfterContentChecked {
  @Input() vm: any;
  @Input() showSpecificDates;
  @Output() dateChange = new EventEmitter<void>();


  constructor(public dateFilter: DateFilterService) {
  }

  ngOnInit() {
    this.vm.monthCount = 0;
  }

  get showSpecificDatesValue(): boolean {
    return this.vm?.showSpecificDates ?? this.showSpecificDates;
  }

  set showSpecificDatesValue(value: boolean) {
    if (this.vm) {
      this.vm.showSpecificDates = value;
    } else {
      this.showSpecificDates = value;
    }
  }

  ngAfterContentChecked() {
    this.dateValueChange();
  }

  handleDateChange() {
    if (this.vm) {
      this.vm.report = [];
    }
    this.dateValueChange();
    this.dateChange.emit();
  }

  dateValueChange() {
    let monthCount;
    if (this.vm.request.toDate && this.vm.request.fromDate) {
      const tempToDate: any = new Date(this.vm.request.toDate);
      const tempFromDate: any = new Date(this.vm.request.fromDate);
      monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      if (monthCount > 0) {
        this.vm.monthCount = monthCount;
      } else {
        this.vm.monthCount = 0;
      }
    }
  }
}
